import React from 'react';

import Button from '@/components/atoms/Button';

export type FilterPopupProps = {
  title: string;
  description: string;
  onApply: () => void;
  onClear: () => void;
  children: React.ReactNode;
  className?: string;
  goToPage?: (value: number) => void;
};

const FilterPopup: React.FC<FilterPopupProps> = ({
  title,
  description,
  onApply,
  onClear,
  children,
  className = '',
  goToPage,
}) => (
  <div className={`p-6 text-sm ${className}`}>
    {/* Header */}
    <div className="mb-6">
      <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
      <p className="mt-1 text-sm text-gray-500">{description}</p>
    </div>
    <div className="space-y-5">{children}</div>
    {/* Actions */}
    <div className="mt-8 flex gap-3 border-t border-gray-200 pt-4">
      <Button type="delete" rounded="md" text="Clear" onClick={onClear} className="flex-1" />
      <Button
        type="primary"
        rounded="md"
        text="Apply"
        onClick={() => {
          onApply();
          if (goToPage) {
            goToPage(0);
          }
        }}
        className="flex-1"
      />
    </div>
  </div>
);

export default FilterPopup;
